import { FormattedMessage as FM } from "react-intl";

import { STYLE_HOTEL_INPUT } from "../constants";

function HotelInput({ name, label, type = "text", form, defaults, onChange }) {
  const inherited = !form[name] && defaults[name];
  return (
    <label className="block">
      <span className="mb-1 flex items-center gap-2 text-sm text-neutral-500">
        <FM id={label || `melhous.${name}`} />
        {inherited && (
          <span className="rounded bg-sky-50 px-1.5 py-0.5 text-[11px] font-medium text-sky-800">
            <FM id="melhous.dash.color.from_hotel" />
          </span>
        )}
      </span>
      <input
        type={type}
        value={form[name]}
        placeholder={type === "text" && defaults[name] ? String(defaults[name]) : ""}
        onChange={(event) => onChange(name, event.target.value)}
        className={STYLE_HOTEL_INPUT}
      />
    </label>
  );
}

export default HotelInput;
